import { Table } from "@4uhub/lib4uhub";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import MainApiService from "../../../../services/mainApi.service";
import { IAccessTokens } from "../../../../models/access-token";
import { Chip } from "@mui/material";

const translationPath = "page.4uBus.uBusAutomationRobot.";
const EXAM_MACHINE_FILES_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/4uBusAutomationRobot/";
const examMachineFilesService = new MainApiService<IAccessTokens>(
  EXAM_MACHINE_FILES_ROUTE
);

const FileIntegrationPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IAccessTokens>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
      renderCell: (params) => params.value ?? "-",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => params.value ?? "-",
    },
    {
      field: "path",
      headerName: t(translationPath + "path") || "Path",
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IAccessTokens>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IAccessTokens>
      showDefaultMacroFilters={false}
      service={examMachineFilesService}
      columns={columns}
      title={t(translationPath + "exam_machine_files")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for an exam machine files"
      }
      addButtonLabel={
        t(translationPath + "add_exam_machine_files") ||
        "Add Exam Machine Files"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default FileIntegrationPage;
